import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import c from "../../../../internal/CopyText/CopyText.js";
import d from "../../../../../core/Context/useCoreContext.js";
import t from "../../../../internal/Typography/Typography.js";
import { TypographyElement as a, TypographyVariant as i } from "../../../../internal/Typography/types.js";
const x = ({
  className: p,
  content: e,
  contentClassName: l,
  textToCopy: o,
  label: n,
  labelClassName: m
}) => {
  const { i18n: s } = d();
  return /* @__PURE__ */ r("div", { className: p, children: [
    /* @__PURE__ */ r("dt", { className: m, children: /* @__PURE__ */ r(t, { el: a.SPAN, variant: i.CAPTION, children: s.get(n) }) }),
    /* @__PURE__ */ r("dd", { className: l, children: o ? /* @__PURE__ */ r(c, { buttonLabel: e, textToCopy: o, showCopyTextTooltip: !1, type: "Text" }) : /* @__PURE__ */ r(t, { el: a.SPAN, variant: i.BODY, children: e }) })
  ] });
};
export {
  x as AccountDetail
};
